window.disabledPrefs = window.disabledPrefs || [
  "okinawa",
];

const disabledPrefsAsSet = new Set(window.disabledPrefs);

const areas = [
  {
    title: "北海道・東北",
    children: [
      "hokkaido",
      "aomori",
      "akita",
      "iwate",
      "miyagi",
      "yamagata",
      "fukushima",
    ],
  },
  {
    title: "関東",
    children: [
      "tokyo",
      "kanagawa",
      "saitama",
      "chiba",
      "tochigi",
      "gunma",
      "ibaraki",
    ],
  },
  {
    title: "東海・甲信越",
    children: [
      "aichi",
      "gifu",
      "mie",
      "shizuoka",
      "niigata",
      "ishikawa",
      "nagano",
      "fukui",
      "toyama",
      "yamanashi",
    ],
  },
  {
    title: "近畿・中国",
    children: [
      "osaka",
      "hyogo",
      "kyoto",
      "nara",
      "wakayama",
      "shiga",
      "okayama",
      "hiroshima",
      "tottori",
      "shimane",
      "yamaguchi"
    ],
  },
  {
    title: "四国",
    children: ["tokushima", "kagawa", "ehime", "kouchi"],
  },
  {
    title: "九州",
    children: [
      "fukuoka",
      "saga",
      "nagasaki",
      "kumamoto",
      "oita",
      "miyazaki",
      "kagoshima",
      "okinawa",
    ],
  },
];

for (const area of areas) {
  area.children = area.children.filter(item => !disabledPrefsAsSet.has(item));
}

export default areas;



// WEBPACK FOOTER //
// ./common/areas.js